import { gql } from 'graphql-tag';

export const GET_MAINTENANCE_TASK_TEMPLATE = gql`
  query GetMaintenanceTaskTemplate($id: ID!) {
    maintenanceTaskTemplate(id: $id) {
      id
      accountId
      name
      description
      type
      isMandatory
      targetValue
      createdAt
      updatedAt
      deletedAt
      tasks {
        id
        name
        description
        type
        isMandatory
        targetValue
        taskValue
        referenceImages
        sortOrder
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_MAINTENANCE_TASK_TEMPLATES = gql`
  query GetMaintenanceTaskTemplates($skip: Int, $take: Int) {
    maintenanceTaskTemplates(skip: $skip, take: $take) {
      data {
        id
        accountId
        name
        description
        createdAt
        updatedAt
        tasks {
          id
          name
          description
          type
          isMandatory
          taskValue
          targetValue
          referenceImages
          sortOrder
        }
      }
      total
      page
      limit
    }
  }
`;
